import { forwardRef } from "react";
import "./styles.css";

export const Button = forwardRef<
  HTMLButtonElement,
  React.ButtonHTMLAttributes<HTMLButtonElement>
>((props, ref) => {
  return <button ref={ref} className="QuestionButton" {...props} />;
});
